import { baseApi } from '@/app/baseApi';

export const analyticsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAnalyticsDashboard: builder.query<string, string>({
      query: (tenantId) => ({
        url: `analytics/${tenantId}`,
        endpoint: 'main',
      }),
      // Response is just a string URL, not an object
      transformResponse: (response: string) => response,
      providesTags: ['Analytics'],
    }),
  }),
});

export const { useGetAnalyticsDashboardQuery } = analyticsApi;
